import { usePageHeader } from "@/components/layouts/lib/page-header";
import { EditUserDialog } from "./users/components/dialogs/EditUserDialog";
import { UsersPageContent } from "./users/components/UsersPageContent";
import { UsersPageIntro } from "./users/components/UsersPageIntro";
import { UsersStatsGrid } from "./users/components/UsersStatsGrid";
import { UsersToolbar } from "./users/components/UsersToolbar";
import { useUsersPageActions } from "./users/hooks/useUsersPageActions";
import { useUsersPageData } from "./users/hooks/useUsersPageData";
import { useUsersPageState } from "./users/hooks/useUsersPageState";
import { USERS_PAGE_GUIDE, USERS_PAGE_TIP } from "./users/usersPage.constants";

export default function UsersPage() {
  const pageState = useUsersPageState();
  const pageData = useUsersPageData({
    search: pageState.search,
    roleFilter: pageState.roleFilter,
  });
  const actions = useUsersPageActions();

  usePageHeader({
    title: "Utilisateurs",
    helpTopic: "utilisateurs",
    guide: {
      steps: USERS_PAGE_GUIDE,
      tip: USERS_PAGE_TIP,
    },
  });

  return (
    <div>
      <UsersPageIntro onCreated={actions.reloadUsers} />
      <UsersStatsGrid stats={pageData.stats} statsLoading={pageData.statsLoading} />
      <UsersToolbar
        search={pageState.search}
        roleFilter={pageState.roleFilter}
        viewMode={pageState.viewMode}
        total={pageData.total}
        onSearchChange={pageState.setSearch}
        onRoleFilterChange={pageState.setRoleFilter}
        onViewModeChange={pageState.setViewMode}
      />
      <UsersPageContent
        users={pageData.users}
        viewMode={pageState.viewMode}
        isLoading={pageData.isLoading}
        busyId={actions.busyId}
        onEdit={pageState.setEditing}
        onResetOtp={actions.resetOtp}
        onToggleActivation={actions.toggleActivation}
      />
      <EditUserDialog
        targetUser={pageState.editing}
        onClose={() => pageState.setEditing(null)}
        onUpdated={actions.reloadUsers}
      />
    </div>
  );
}
